const SelectLocation = ({ Locations, selectedLocation, setSelectedLocation }) => {
    return (
        <select
        id='location-select'
        className='choice-select'
        value={selectedLocation}
        onChange={(e) => setSelectedLocation(e.target.value)}
        >
            {selectedLocation === '' ? <option value="">
                ------
            </option> : null}
            {Locations.map((location) => (
                <option
                    key={location.id}
                    value={location.id}
                >
                    {location.place} {location.thoroughfare} {location.type_line}
                </option>
            ))}
        </select>
    );
};

export default SelectLocation;